<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CH-T"><strong>Pompom Cushion</strong></h1>
<p class="INTRO1">This stockinette stitch cushion is embellished with pompoms made from primary colors to brighten up a child’s room.</p>
<h4 class="CHD"><strong><em>Skill Level-Beginner</em></strong></h4>
<p class="Image-C"><img alt="" src="OEBPS/Images/4-1.jpg"/></p>
<div class="SBDIV">
<h4 class="MLAHD">You Will Need</h4>
<h5 class="MLBHD">Yarn</h5>
<p class="ML-BL1-1st">•  2 × 2<span class="fraction"><sup>1</sup>⁄<sub>2</sub></span>oz (100g) balls of light-weight (DK) acrylic yarn (322yd/295m per ball) in cream (A)</p>
<p class="ML-BL1-last">•  For pompoms: 1 × 1<span class="fraction"><sup>3</sup>⁄<sub>4</sub></span>oz (50g) ball of each of blue, red, green and yellow acrylic or wool yarn</p>
<h5 class="MLBHD">Knitting Needles</h5>
<p class="ML-BL1-1st">•  One pair size 6 (4mm)</p>
<h5 class="MLBHD">Other Materials</h5>
<p class="ML-BL1-1st">•  16in (40cm) square cushion pad</p>
</div>
<h2 class="AHD"><strong>Finished Measurements</strong></h2>
<p class="BOD1">16in (40cm) square</p>
<h2 class="AHD"><strong>Gauge</strong></h2>
<p class="BOD1">22 sts and 28 rows to 4in (10cm) square measured over st st (1 row k, 1 row p) using size 6 (4mm) needles</p>
<h2 class="AHD"><strong>Knit Notes</strong></h2>
<p class="BOD1">You could use shop-bought pompoms, but it’s much more fun to make your own, and you can create exactly the colors and textures you want.</p>
<h2 class="AHD"><strong>Knit Your Cushion</strong></h2>
<h3 class="BHD"><strong>BACK AND FRONT (MAKE 2 THE SAME)</strong></h3>
<p class="BOD1">Using size 6 (4mm) needles and A, cast on 88 sts.</p>
<p class="BOD1">Work in st st (1 row k, 1 row p) until work measures 16in (40cm), ending with a p row.</p>
<p class="BOD1">Bind off.</p>
<h2 class="AHD"><strong>Finish Your Cushion</strong></h2>
<p class="BOD1">Sew in all ends neatly. Press according to instructions on ball bands.</p>
<p class="BOD1">Make sufficient pompoms to cover the front of the cushion. Sew the pompoms on.</p>
<p class="BOD1">Join back and front together around three sides. Insert cushion pad and sew remaining side closed.</p>
<h3 class="BHD"><strong>MAKING A POMPOM</strong></h3>
<p class="BOD1">Cut two circles out of stiff cardboard, making them the same diameter that you require for the finished pompom. Cut out a hole in the center of each one half of this size. Place the card circles together and begin winding yarn around them until the hole in the center is filled (<a href="#/OEBPS/#fig1">Fig 1</a>).</p>
<p class="BOD1">Carefully cut through the loops all the way around, being careful not to let any yarn strands escape (<a href="#/OEBPS/#fig2">Fig 2</a>).</p>
<p class="BOD1">Pull a length of yarn between the two pieces of cardboard, knot the two ends together and pull tightly around the center of the pompom. Secure with a tight knot (<a href="#/OEBPS/#fig3">Fig 3</a>).</p>
<p class="BOD1">Pull out the cardboard circles. Fluff up the pompom, trimming any uneven ends, but leave the two yarn ends for sewing on.</p>
<p class="BOD1" style="margin-top: 1em; font-size: 17pt"><strong>1</strong></p>
<p class="Image-C" id="fig1"><img alt="" src="OEBPS/Images/7-1.jpg"/></p>
<p class="BOD1" style="margin-top: 1em; font-size: 17pt"><strong>2</strong></p>
<p class="Image-C" id="fig2"><img alt="" src="OEBPS/Images/7-2.jpg"/></p>
<p class="BOD1" style="margin-top: 1em; font-size: 17pt"><strong>3</strong></p>
<p class="Image-C" id="fig3"><img alt="" src="OEBPS/Images/7-3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?6e49e442